/* eslint-disable @typescript-eslint/no-require-imports */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, {useCallback} from 'react';
import {
  Dimensions,
  Linking,
  Platform,
  ScrollView,
  Text,
  View,
} from 'react-native';
import {connect} from 'react-redux';
import {VoyageServices} from '../../../../services/applicatif/voyages';

import {
  useFocusEffect,
  useNavigation,
  useRoute,
} from '@react-navigation/native';
import dayjs from 'dayjs';
import 'dayjs/locale/fr';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import {
  addThousandSeparator,
  decodeStringWithAccents,
  formatDateTo,
} from '../../../../common/utils/functions';
import config from '../../../../data/config';
import {initModalData} from '../../../../data/constants/Assurance/AssuranceVoyage/souscription';
import {ApiResponse} from '../../../../data/types/interface/api';
import {
  Beneficiary,
  ContratVoyage,
} from '../../../../data/types/interface/Assurance/AssuranceVoyage';
import {ModalDataDTO} from '../../../../data/types/interface/Assurance/AssuranceVoyage/souscription';
import mapDispatchToProps from '../../../../services/redux/mapDispatchToProps';
import mapStateToProps from '../../../../services/redux/mapStateToProps';
import {MoreInfo} from '../../../components/Assurance/Voyage/MoreInfo';
import {
  BoxShadowed,
  ButtonItems,
  DetailAssuranceContainer,
  LinkWithIconDownload,
} from '../../../components/AssuranceVoyage';
import {createPDF as createMobilePDF} from '../../../components/AttestationExport/index';
import {createPDF} from '../../../components/AttestationExport/index.web';
import {RegisterFonts} from '../../../components/AttestationExport/MonAttesation';
import DisplayImage from '../../../components/DisplayImage';
import {HeaderScreen} from '../../../components/Header/HeaderScreen';
import Label from '../../../components/Label';
import {OrderedList} from '../../../components/List/OrderedList';
import {UnorderedList} from '../../../components/List/UnorderedList';
import {Loader} from '../../../components/Loader';
import ConfirmationModal from '../../../components/Modal/ConfirmationModal';
import {styles} from './styles';
dayjs.extend(customParseFormat);

interface DetailContratVoyageProps {
  user: any;
  // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
  getAgence?: Function;
}
const DetailContratVoyageFC = ({user, getAgence}: DetailContratVoyageProps) => {
  const currentUser = user?.data?.utilisateur;
  const windowWidth = Dimensions.get('window').width;
  const [detailContrat, setDetailContrat] = React.useState<
    ContratVoyage | undefined
  >(undefined);
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [status, setStatus] = React.useState<boolean>(false);
  const [modalData, setModalData] = React.useState<ModalDataDTO>({
    ...initModalData,
  });
  const [listAgence, setListAgence] = React.useState<Array<any>>([]);
  const [isOpened, setIsOpened] = React.useState<boolean>(false);

  const {params}: any = useRoute();
  const {navigate}: any = useNavigation();
  const listItems = React.useMemo<Array<any>>(() => {
    const list: Array<any> = [];

    if (
      detailContrat?.status !== 'resilier' &&
      dayjs().isBefore(dayjs(detailContrat?.dateDebut, 'DD/MM/YYYY'))
    ) {
      list.push({
        libelle: "Demande d'avenant",
        action: () => {
          setModalData({
            status: true,
            title: 'Information',
            content: ``,
            children: (
              <ScrollView style={{flex: 1}}>
                <OrderedList
                  items={[
                    <View style={[Platform.OS !== 'web' ? {width: 280} : {}]}>
                      <Text style={{fontWeight: 'bold', maxWidth: '90%'}}>
                        Une modification de votre contrat en cours est
                        autorisée, quand : (1 jour au plus tard avant la date
                        d’effet)
                      </Text>
                      <UnorderedList
                        items={[
                          'Cela n’impacte pas la grille tarifaire initiale à laquelle vous êtes rattachée càd le nombre de jours dont vous êtes couverts (7j, 10j, 15j, 21j, 30j, 60j, 90j, 180j)',
                          'Vous devez reporter ou décaler uniquement votre date de départ',
                          'Vous devez reporter autant votre date de départ que le retour',
                          'Avant la date d’effet du contrat, vous avez la possibilité de modifier votre contrat par 2 fois au maximum',
                        ]}
                      />
                    </View>,
                    <View style={[Platform.OS !== 'web' ? {width: 280} : {}]}>
                      <Text style={{fontWeight: 'bold', marginBottom: 5}}>
                        Une souscription supplémentaire est à faire, si la durée
                        de votre séjour devra être prolongée.
                      </Text>
                      <Text>
                        Ex : durée initiale : 30j. Mais prolongation du séjour
                        de 5 jours, souscription d’un complément de couverture
                        de 7j
                      </Text>
                    </View>,
                    <View style={[Platform.OS !== 'web' ? {width: 280} : {}]}>
                      <Text style={{fontWeight: 'bold'}}>
                        Une résiliation de votre contrat en cours doit se faire,
                        quand :
                      </Text>
                      <UnorderedList
                        items={[
                          `La modification à apporter doit vous faire passer d’une grille tarifaire à une autre avec un changement de la date d’effet du contrat et que le nombre de modification maximum autorisée est déjà épuisée`,
                          `(Ex. souscription initiale de 15j, modification de la date d’effet et du nombre de jour à 30j : résiliation)`,
                          'Suite à un « Refus de visa », votre voyage est à reporter ou à annuler',
                          'Suite à une Résiliation, vous devez vous rendre auprès d’une agence « A.R.O » la plus proche pour récupérer le remboursement de votre ristourne',
                        ]}
                      />
                    </View>,
                    <View style={[Platform.OS !== 'web' ? {width: 280} : {}]}>
                      <Text style={{fontWeight: 'bold'}}>
                        Toute éventuelle modification est autorisée, seulement 1
                        jour au plus tard avant la date d’effet de votre
                        contrat!!!!
                      </Text>
                    </View>,
                  ]}
                />
              </ScrollView>
            ),
            btn1: 'Poursuivre',
            btn2: 'Annuler',
            handleBtn1: () => {
              setModalData({...initModalData});
              navigate('ModificationAssuranceVoyage', {
                policyId: detailContrat?.policyId,
                message: detailContrat?.destination,
                destination: detailContrat?.destination,
                policyNumber: detailContrat?.policyNumber,
                dateDebut: detailContrat?.dateDebut,
                dateFin: detailContrat?.dateFin,
                category: detailContrat?.categorie,
                assure: detailContrat?.beneficiaries.map(currentAssured => ({
                  id: currentAssured.id,
                  nom: currentAssured.last_name,
                  prenom: currentAssured.first_name,
                  email: currentAssured.email,
                  phoneNumber: currentAssured.phone_number,
                  passeportNumber: currentAssured.passport_number,
                  axaId: currentAssured.axaId,
                  passeportFile: currentAssured.passportFile,
                })),
              });
            },
            handleBtn2: () => setModalData({...initModalData}),
          });
        },
        image: require('../../../../ressources/images/Edit.png'),
      });
    }
    if (detailContrat?.status !== 'resilier') {
      list.push({
        libelle: 'Résilier assurance',
        action: () =>
          navigate('ResiliationAssuranceVoyage', {
            policyId: detailContrat?.policyId,
            message: detailContrat?.destination,
            destination: detailContrat?.destination,
            policyNumber: detailContrat?.policyNumber,
          }),
        image: require('../../../../ressources/images/close-1.png'),
      });
    }

    return list;
  }, [detailContrat]);

  const {detailContrat: getDetailContrat} = VoyageServices();

  const handleGetDetailContrat = useCallback((id: string) => {
    setIsLoading(true);
    getDetailContrat(id)
      .then((res: ApiResponse) => {
        setIsLoading(false);
        if (!res.isError && res?.data) {
          setDetailContrat(res.data);
        }
      })
      .catch((error: any) => {
        console.log('error', error);
        setIsLoading(false);
      });
  }, []);

  const handleDownloadPDF = useCallback(
    async (assured: Beneficiary) => {
      if (detailContrat) {
        if (config.pdfAsLink) {
          Linking.openURL(
            `${config.baseURL}api/common/pdf-generator?type=voyage&numeroPolice=${detailContrat?.policyNumber}`,
          );
        } else {
          dayjs.locale('fr');

          const dataToSend = {
            typeContrat: 'voyage',
            avenantNo: `${detailContrat?.changement || 0 + 1}`,
            nomPrenomAssure: `${assured?.first_name} ${assured.last_name}`,
            noCompte: '',
            branche: `ASSISTANCE VOYAGE`,
            agence: `${detailContrat?.agence}`,
            code: listAgence.length
              ? listAgence.find(
                  (item: any) => item.nom === detailContrat?.agence,
                )?.id
              : 'null',
            effetPolice: detailContrat?.dateDebut,
            echeancePolice: detailContrat?.dateFin,
            expirationAvenant: detailContrat?.dateFin,
            adresseSouscripteur: `${currentUser?.adresse || ''}`,
            nomPrenomSouscripteur: `${detailContrat.nomPrenomContractant}`,
            dateCreation: `${dayjs(
              detailContrat.ristourne.date_creation,
            ).format('DD MMMM YYYY')}`,
            numeroPolice: `${detailContrat.policyNumber}`,
            motif: `${detailContrat.ristourne.motif}`,
            primeTTC: `${addThousandSeparator(
              Math.round(detailContrat.ristourne.valeur),
            )}`,
            primeNette: `${addThousandSeparator(
              Math.round(detailContrat.ristourne.prime_net),
            )}`,
            accessoire: `${addThousandSeparator(
              Math.round(detailContrat.ristourne.accessoire),
            )}`,
            primeTE: `${addThousandSeparator(
              Math.round(detailContrat.ristourne.te),
            )}`,
            primeTVA: `${addThousandSeparator(
              Math.round(detailContrat.ristourne.tva),
            )}`,
            dateEcriture: `${dayjs(
              detailContrat.ristourne.date_creation,
            ).format('DD MMMM YYYY')}`,
          };
          // TODO: Test - uncomment
          if (Platform.OS !== 'web') {
            createMobilePDF(dataToSend, () => console.log('finished'));
          } else {
            createPDF(dataToSend, () => console.log('finished'));
          }
        }
      }
    },
    [detailContrat],
  );

  useFocusEffect(
    React.useCallback(() => {
      RegisterFonts();
      handleGetDetailContrat(params?.id);
      typeof getAgence === 'function' &&
        getAgence({}, (res: any) => {
          if (res && !res.isError && res.data && res.data.items) {
            setListAgence(res.data.items);
          }
          setIsLoading(false);
        });
    }, []),
  );

  return (
    <View style={{flex: 1, backgroundColor: 'white'}}>
      <HeaderScreen
        title={`POLICE N° ${params.id}`}
        type="ChangeScreen"
        action={() => navigate('MesContrats')}
        noBreadcrumb={false}
      />

      {isLoading ? <Loader /> : null}

      {!isLoading && status ? (
        <ConfirmationModal
          title="Erreur"
          content="Erreur lors de la recuperation de données."
          btn1="OK"
          handleBtn1={() => {
            handleGetDetailContrat(params?.id);
            setStatus(false);
          }}
        />
      ) : null}
      {!isLoading && detailContrat ? (
        <View style={{flex: 1}}>
          <DetailAssuranceContainer>
            <Label
              style={{marginHorizontal: 20, marginBottom: 20}}
              title={`${
                detailContrat.status === 'resilier'
                  ? 'Ce contrat a été résilié'
                  : ''
              }`}
              type="fourthTitle"
            />
            <BoxShadowed>
              <Label
                style={{paddingBottom: 10}}
                title="Résumé de votre voyage"
              />

              <View>
                <Label title={'Destination :'} type="titleGreen14" />
                <Label
                  title={`${decodeStringWithAccents(
                    detailContrat.destination,
                  )} Area`}
                />
              </View>
              <View>
                <Label title={'Vous voyagez du :'} type="titleGreen14" />
                <Label
                  title={`${formatDateTo(
                    detailContrat.dateDebut,
                    'DD/MM/YYYY',
                  )} au ${formatDateTo(detailContrat.dateFin, 'DD/MM/YYYY')}`}
                />
              </View>
              <View>
                <Label title={'Police N° :'} type="titleGreen14" />
                <Label title={`${detailContrat.policyNumber}`} />
              </View>
            </BoxShadowed>

            <View
              style={{
                flexDirection: 'row',
                flexWrap: 'wrap',
                paddingBottom: 10,
              }}>
              {listItems.map((element: any, index: number) => (
                <ButtonItems
                  key={`detailContrat_${index}`}
                  image={element.image}
                  action={element.action}
                  libelle={element.libelle}
                />
              ))}
            </View>

            <View style={{paddingHorizontal: 10}}>
              <LinkWithIconDownload
                text="Conditions Générales.pdf"
                url={config.voyageCG}
              />

              <LinkWithIconDownload
                text="Notice d'information.pdf"
                url={config.voyageNotice}
              />
            </View>

            <MoreInfo
              status={isOpened}
              onCollapse={() =>
                isOpened
                  ? setIsOpened(!isOpened)
                  : setModalData({
                      status: true,
                      title: 'Information',
                      content: ``,
                      children: (
                        <ScrollView style={{flex: 1}}>
                          <OrderedList
                            items={[
                              <View
                                style={[
                                  Platform.OS !== 'web' ? {width: 280} : {},
                                ]}>
                                <Text
                                  style={{fontWeight: 'bold', maxWidth: '90%'}}>
                                  Une modification de votre contrat en cours est
                                  autorisée, quand : (1 jour au plus tard avant
                                  la date d’effet)
                                </Text>
                                <UnorderedList
                                  items={[
                                    'Cela n’impacte pas la grille tarifaire initiale à laquelle vous êtes rattachée càd le nombre de jours dont vous êtes couverts (7j, 10j, 15j, 21j, 30j, 60j, 90j, 180j)',
                                    'Vous devez reporter ou décaler uniquement votre date de départ',
                                    'Vous devez reporter autant votre date de départ que le retour',
                                    'Avant la date d’effet du contrat, vous avez la possibilité de modifier votre contrat par 2 fois au maximum',
                                  ]}
                                />
                              </View>,
                              <View
                                style={[
                                  Platform.OS !== 'web' ? {width: 280} : {},
                                ]}>
                                <Text
                                  style={{fontWeight: 'bold', marginBottom: 5}}>
                                  Une souscription supplémentaire est à faire,
                                  si la durée de votre séjour devra être
                                  prolongée.
                                </Text>
                                <Text>
                                  Ex : durée initiale : 30j. Mais prolongation
                                  du séjour de 5 jours, souscription d’un
                                  complément de couverture de 7j
                                </Text>
                              </View>,
                              <View
                                style={[
                                  Platform.OS !== 'web' ? {width: 280} : {},
                                ]}>
                                <Text style={{fontWeight: 'bold'}}>
                                  Une résiliation de votre contrat en cours doit
                                  se faire, quand :
                                </Text>
                                <UnorderedList
                                  items={[
                                    `La modification à apporter doit vous faire passer d’une grille tarifaire à une autre avec un changement de la date d’effet du contrat et que le nombre de modification maximum autorisée est déjà épuisée`,
                                    `(Ex. souscription initiale de 15j, modification de la date d’effet et du nombre de jour à 30j : résiliation)`,
                                    'Suite à un « Refus de visa », votre voyage est à reporter ou à annuler',
                                    'Suite à une Résiliation, vous devez vous rendre auprès d’une agence « A.R.O » la plus proche pour récupérer le remboursement de votre ristourne',
                                  ]}
                                />
                              </View>,
                              <View
                                style={[
                                  Platform.OS !== 'web' ? {width: 280} : {},
                                ]}>
                                <Text style={{fontWeight: 'bold'}}>
                                  Toute éventuelle modification est autorisée,
                                  seulement 1 jour au plus tard avant la date
                                  d’effet de votre contrat!!!!
                                </Text>
                              </View>,
                            ]}
                          />
                        </ScrollView>
                      ),
                      btn1: 'Poursuivre',
                      btn2: 'Annuler',
                      handleBtn1: () => {
                        setModalData({...initModalData});
                        setIsOpened(!isOpened);
                      },
                      handleBtn2: () => {
                        setModalData({...initModalData});
                        setIsOpened(!isOpened);
                      },
                    })
              }>
              <View>
                {detailContrat.beneficiaries.map(currentAssured => {
                  return (
                    <BoxShadowed
                      key={`benficiaire_${currentAssured.id}`}
                      style={
                        Platform.OS === 'web'
                          ? {
                              flexDirection: 'row',
                              justifyContent: 'space-between',
                              alignItems: 'center',
                            }
                          : {}
                      }>
                      <View>
                        <Label title="Bénéficiaire" />
                        <View>
                          <Label title={'Nom :'} type="titleGreen14" />
                          <Label
                            title={decodeStringWithAccents(
                              currentAssured.last_name,
                            )}
                          />
                        </View>
                        <View>
                          <Label title={'Prénom :'} type="titleGreen14" />
                          <Label
                            title={decodeStringWithAccents(
                              currentAssured.first_name,
                            )}
                          />
                        </View>
                        <View>
                          <Label title={'E-mail :'} type="titleGreen14" />
                          <Label
                            title={decodeStringWithAccents(
                              currentAssured.email,
                            )}
                          />
                        </View>
                        <View>
                          <Label
                            title={'Numéro de passeport :'}
                            type="titleGreen14"
                          />
                          <Label title={currentAssured.passport_number} />
                        </View>
                        <View>
                          <Label
                            title={'Numéro de téléphone :'}
                            type="titleGreen14"
                          />
                          <Label title={currentAssured.phone_number} />
                        </View>
                        {detailContrat?.status !== 'resilier' ? (
                          <LinkWithIconDownload
                            text="Attestations.pdf"
                            url={currentAssured?.certificate}
                          />
                        ) : (
                          <LinkWithIconDownload
                            text="Avenant de résiliation.pdf"
                            url={currentAssured?.certificate}
                            onPress={() => handleDownloadPDF(currentAssured)}
                          />
                        )}
                      </View>
                      <View>
                        <DisplayImage
                          url={`voyage/files/image/${currentAssured.passportFile}`}
                          style={
                            Platform.OS === 'web'
                              ? {
                                  width: 400,
                                  height: 250,
                                  resizeMode: 'contain',
                                }
                              : {
                                  width: '100%',
                                  height: 250,
                                  resizeMode: 'contain',
                                }
                          }
                        />
                      </View>
                    </BoxShadowed>
                  );
                })}

                <BoxShadowed>
                  <Label title="Souscripteur" />
                  <View>
                    <Label title={'Nom :'} type="titleGreen14" />
                    <Label title={currentUser?.nom} />
                  </View>
                  <View>
                    <Label title={'Prénom :'} type="titleGreen14" />
                    <Label title={currentUser?.prenom} />
                  </View>
                  <View>
                    <Label title={'Email'} type="titleGreen14" />
                    <Label title={currentUser?.email} />
                  </View>
                </BoxShadowed>

                {detailContrat?.status === 'resilier' &&
                detailContrat.ristourne ? (
                  <View style={{padding: 10}}>
                    <View style={styles.resultContainer}>
                      <Text style={styles.resultDestination}>{`Montant ${
                        detailContrat?.ristourne?.status === 'pending'
                          ? 'à rembourser'
                          : 'remboursé'
                      } par ARO`}</Text>
                      <View style={{alignItems: 'center'}}>
                        <Text
                          style={[
                            styles.resultMontant,
                            {
                              width: 250,
                              color:
                                detailContrat?.ristourne?.status === 'pending'
                                  ? 'red'
                                  : 'silver',
                              textAlign: 'center',
                              marginLeft: Platform.OS === 'web' ? -25 : 0,
                            },
                          ]}>{`- ${addThousandSeparator(
                          Math.round(detailContrat?.ristourne?.valeur),
                        )} Ar`}</Text>
                      </View>
                    </View>
                  </View>
                ) : null}
                <View style={{padding: 10}}>
                  <View style={styles.resultContainer}>
                    <Text
                      style={
                        styles.resultDestination
                      }>{`${detailContrat.destination.toUpperCase()} - ${'single'}`}</Text>
                    <View style={{alignItems: 'center'}}>
                      <Text
                        style={[
                          styles.resultMontant,
                          {width: 250, textAlign: 'center'},
                        ]}>{`${
                        detailContrat.primeTtc
                          ? addThousandSeparator(detailContrat.primeTtc)
                          : ''
                      } Ar`}</Text>
                    </View>
                  </View>
                </View>
              </View>
            </MoreInfo>

            <View style={{height: 50}} />
          </DetailAssuranceContainer>
        </View>
      ) : null}
      {modalData.status ? (
        <ConfirmationModal
          contentStyle={
            {
              textAlign: 'left',
              maxHeight: 200,
              overflow: Platform.OS === 'web' ? 'auto' : 'scroll',
            } as any
          }
          title={modalData.title}
          content={modalData.content}
          btn1={modalData.btn1}
          btn2={modalData.btn2}
          handleBtn1={modalData.handleBtn1}
          handleBtn2={modalData.handleBtn2}
          childContainerStyle={{height: '80%'}}
          children={modalData.children}
          modalViewStyle={[
            {maxWidth: windowWidth > 800 ? 800 : '90%'},
            Platform.OS === 'web' && {
              maxHeight: '95%',
            },
          ]}
          titleStyle={{maxWidth: windowWidth > 800 ? 800 : '90%'}}
        />
      ) : null}
    </View>
  );
};

export const DetailContratVoyage: any = connect(
  mapStateToProps,
  mapDispatchToProps,
)(DetailContratVoyageFC);

export default DetailContratVoyage;
